import { memo, useEffect, useMemo } from 'react';
import * as L from 'leaflet';
import { useMap } from 'react-leaflet';
import { GeoSearchControl, GoogleProvider } from 'leaflet-geosearch';
import markerIcon from '../static/blue-pin.png';
import config from '../config';

// see https://github.com/smeijer/leaflet-geosearch#geosearchcontrol
const SearchBar = ({ position = 'topright', onLocationSearch }) => {
  const map = useMap();

  const provider = useMemo(
    () =>
      new GoogleProvider({
        region: 'US',
        version: 'weekly',
        apiKey: process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY,
      }),
    [],
  );

  useEffect(() => {
    const searchControl = new GeoSearchControl({
      provider,
      position,
      marker: {
        icon: new L.Icon({ iconUrl: markerIcon, iconSize: [35, 60] }),
        draggable: false,
        zIndexOffset: -1000,
        opacity: 0.7,
      },
      ...config.geosearch,
    });

    if (onLocationSearch) {
      map.on('geosearch/showlocation', (event) => onLocationSearch(event.location.raw));
    }

    map.addControl(searchControl);

    return () => {
      map.off('geosearch/showlocation', onLocationSearch);
      map.removeControl(searchControl);
    };
  }, [map, onLocationSearch, position, provider]);

  return null;
};

export default memo(SearchBar);
